var _path, _path2, _mask, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectReanimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 21C42.7909 21 41 22.7909 41 25V41H25C22.7909 41 21 42.7909 21 45V59C21 61.2091 22.7909 63 25 63H41V79C41 81.2091 42.7909 83 45 83H59C61.2091 83 63 81.2091 63 79V63H79C81.2091 63 83 61.2091 83 59V45C83 42.7909 81.2091 41 79 41H63V25C63 22.7909 61.2091 21 59 21H45Z",
    fill: "#3A8761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 21H52V41V63V83H59C61.2091 83 63 81.2091 63 79V63H79C81.2091 63 83 61.2091 83 59V45C83 42.7909 81.2091 41 79 41L63 41V25C63 22.7909 61.2091 21 59 21Z",
    fill: "#2A5B43"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 105,
    height: 105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 52.5C105 81.4949 81.4949 105 52.5 105C23.5051 105 0 81.4949 0 52.5C0 23.5051 23.5051 0 52.5 0C81.4949 0 105 23.5051 105 52.5Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 93C74.8675 93 93 74.8675 93 52.5C93 30.1325 74.8675 12 52.5 12C30.1325 12 12 30.1325 12 52.5C12 74.8675 30.1325 93 52.5 93ZM52.5 105C81.4949 105 105 81.4949 105 52.5C105 23.5051 81.4949 0 52.5 0C23.5051 0 0 23.5051 0 52.5C0 81.4949 23.5051 105 52.5 105Z",
    fill: "#E23E5C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8787 81.8787L81.8787 18.8787L86.1213 23.1213L23.1213 86.1213L18.8787 81.8787Z",
    fill: "#E23E5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectReanimation);
export default __webpack_public_path__ + "static/media/rejectReanimation.82ed5334906eb31066b8a01e2cc0a8c9.svg";
export { ForwardRef as ReactComponent };